import React from 'react';

interface ApolloIconProps {
  height?: number;
  className?: string;
}

/**
 * Apollo's mark as a filled app tile: the pinwheel in black on the brand
 * yellow, rather than a yellow pinwheel on transparent.
 *
 * The mark's own artwork spans 0..35.708 x 0..36.199 and sits off-centre in a
 * 40-unit box, so it is nested in its own `<svg>` whose viewBox is that
 * bounding box. The browser then scales and centres it inside the 24x24 window
 * below, which keeps the optical padding correct without a hand-tuned
 * transform that would need redoing if the paths ever change.
 */
export const ApolloLogo: React.FC<ApolloIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      width={height}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="10" fill="#F8FF2C" />
      <svg x="9" y="9" width="22" height="22" viewBox="0 0 35.708 36.199">
        <path
          d="M19.5993 0.0862365L19.605 13.2568C19.6058 15.3375 17.4222 16.6715 15.6079 15.6986L2.58376 8.7153C3.57706 7.05795 4.82616 5.57609 6.27427 4.32386L16.489 13.8945C17.0303 14.4015 17.8835 13.8518 17.6605 13.1398L13.6992 0.493553C15.0326 0.17147 16.4233 0 17.8536 0C18.4428 0 19.0248 0.0296814 19.5993 0.0862365Z"
          fill="#000000"
        />
        <path
          d="M16.0635 36.1087L16.0578 23.0046C16.057 20.9239 18.2407 19.5898 20.0549 20.5627L33.0838 27.5486C32.0838 29.2016 30.8289 30.6786 29.3751 31.925L19.1738 22.3668C18.6326 21.8598 17.7793 22.4095 18.0023 23.1215L21.9486 35.72C20.6338 36.0329 19.263 36.1989 17.8539 36.1989C17.2497 36.1989 16.6523 36.1683 16.0635 36.1087Z"
          fill="#000000"
        />
        <path
          d="M22.0105 16.77L31.4705 6.39392C30.2362 4.92008 28.7742 3.6486 27.1384 2.63702L20.2306 15.8767C19.2709 17.716 20.5871 19.9298 22.6396 19.9288L35.6183 19.923C35.6775 19.3234 35.7082 18.7151 35.7082 18.0996C35.7082 16.6683 35.5436 15.2761 35.2338 13.9406L22.7549 17.9576C22.0526 18.1837 21.5103 17.3187 22.0105 16.77Z"
          fill="#000000"
        />
        <path
          d="M0.0842758 16.3383L13.0237 16.3325C15.0764 16.3317 16.3923 18.5454 15.4327 20.3846L8.56047 33.5561C6.93095 32.547 5.47394 31.2801 4.24344 29.8121L13.653 19.4914C14.1531 18.9427 13.6107 18.0777 12.9084 18.3037L0.485078 22.3029C0.168551 20.954 0 19.5467 0 18.0994C0 17.5051 0.0290814 16.9177 0.0842758 16.3383Z"
          fill="#000000"
        />
      </svg>
    </svg>
  );
};
